import { User } from '@phosphor-icons/react';

export default User;
